import { useTranslation } from "react-i18next";


/**
 * Convertit un nombre de minutes en format HHh MMmin
*/
export const convertMinutesToHHMM = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    
    return hours === 0 
        ? `${mins}min` 
        : `${String(hours).padStart(2, '0')}h${mins > 0 ? " " + String(mins).padStart(2, '0') + "min" : ""}`;
};

/**
 * Vérifie si une chaîne est au format HH:MM
 * */
export const isValidTimeFormat = (time) => /^([01]\d|2[0-3]):[0-5]\d$/.test(time);



/**
 * Labels des types de signalements d'anomalies rencontrées lors des livraisons
 */
export const typeLabels = {
    client_absent: "Client absent",
    retard_aux_chargement: "Retard au chargement",
    livraison_reportee: "Livraison reportée",
    retard_aux_dechargement: "Retard au déchargement",
    marchandises_manquantes_chargement: "Marchandises manquantes au chargement",
    marchandise_refusee: "Marchandise refusée",
    marchandises_incompletes: "Marchandises incomplètes",
    marchandise_abimee: "Marchandise abîmée",
    route_inaccessible_fermee: "Route inaccessible ou fermée",
    circulation_dense: "Circulation dense",
    autre:"Non précisé"
};


export  function formatSignalementType(type) {
  const mapping = {
    client_absent: "Client absent",
    retard_aux_chargement: "Retard aux chargement",
    livraison_reportée: "Livraison reportée",
    retard_aux_déchargement: "Retard aux déchargement",
    marchandises_manquantes_chargement: "Marchandises manquantes/chargement",
    marchandise_refusée: "Marchandise refusée",
    marchandises_incomplètes: "Marchandises incomplètes",
    marchandise_abîmée: "Marchandise abîmée",
    route_inaccessible_fermée: "Route inaccessible ou fermée",
    circulation_dense: "Circulation dense",
    anomalie_course:"Anomalie course",
    autre: "Autre (précisez)",
  };

  return mapping[type] || type;
}
